import React from "react";
import {
  Card, CardHeader, CardContent, Grid, TextField,
  FormControlLabel, Switch, InputAdornment, Alert
} from "@mui/material";
import { NumericFormatUnit } from "../utils/formatters";
import { useTranslation } from "react-i18next";

export default function InstallmentsSection({
  formData,
  handleText,
  handleSwitch,
  parcelamentoValido,
}) {
  const { t } = useTranslation("products");
  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardHeader
        title={t("form.installmentsCardTitle")}
        sx={{ pb: 0.5, "& .MuiCardHeader-title": { fontSize: 16, fontWeight: 600 } }}
      />
      <CardContent sx={{ pt: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Switch
                  name="parcelamento_semjuros_enabled"
                  checked={Number(formData.parcelamento_semjuros_enabled) === 1}
                  onChange={handleSwitch}
                />
              }
              label={t("form.interestFreeLabel")}
            />
            <TextField
              sx={{ mt: 1 }}
              label={t("form.maxInstallmentsInterestFree")}
              name="parcelamento_semjuros_qtd"
              value={formData.parcelamento_semjuros_qtd}
              onChange={handleText}
              fullWidth
              disabled={Number(formData.parcelamento_semjuros_enabled) !== 1}
              InputProps={{
                inputComponent: NumericFormatUnit,
                endAdornment: <InputAdornment position="end">x</InputAdornment>,
              }}
              inputProps={{ decimalScale: 0 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Switch
                  name="parcelamento_comjuros_enabled"
                  checked={Number(formData.parcelamento_comjuros_enabled) === 1}
                  onChange={handleSwitch}
                />
              }
              label={t("form.withInterestLabel")}
            />
            <Grid container spacing={2} sx={{ mt: 0 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={t("form.maxInstallmentsWithInterestLabel")}
                  name="parcelamento_comjuros_qtd"
                  value={formData.parcelamento_comjuros_qtd}
                  onChange={handleText}
                  fullWidth
                  disabled={Number(formData.parcelamento_comjuros_enabled) !== 1}
                  InputProps={{
                    inputComponent: NumericFormatUnit,
                    endAdornment: <InputAdornment position="end">x</InputAdornment>,
                  }}
                  inputProps={{ decimalScale: 0 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={t("form.interestRateLabel")}
                  name="parcelamento_comjuros_taxa_mes"
                  value={formData.parcelamento_comjuros_taxa_mes}
                  onChange={handleText}
                  fullWidth
                  disabled={Number(formData.parcelamento_comjuros_enabled) !== 1}
                  InputProps={{
                    inputComponent: NumericFormatUnit,
                    endAdornment: (
                      <InputAdornment position="end">{t("form.interestRateSuffix")}</InputAdornment>
                    ),
                  }}
                  inputProps={{ decimalScale: 2 }}
                />
              </Grid>
            </Grid>
          </Grid>

          {!parcelamentoValido && (
            <Grid item xs={12}>
              <Alert severity="warning">
                {t("form.installmentCheckWarning")}
              </Alert>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}
